import { AppStore } from './AppStore'

const store = {
	app: new AppStore()
}

export default store


// WEBPACK FOOTER //
// ./src/store.js